import {Injectable} from '@angular/core';
import {NativeDateAdapter} from '@angular/material/core';

@Injectable()
export class MondayDateAdapter extends NativeDateAdapter {
    override getFirstDayOfWeek(): number {
        return 1;
    }

    override parse(value: unknown): Date | null {
        if (value instanceof Date) {
            return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
        }

        if (typeof value === 'string') {
            const input = value.trim();
            if (!input) return null;

            const germanDate = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(input);
            if (germanDate) {
                const day = Number(germanDate[1]);
                const month = Number(germanDate[2]);
                const year = Number(germanDate[3]);
                const parsed = new Date(year, month - 1, day);

                return parsed.getFullYear() === year &&
                       parsed.getMonth() === month - 1 &&
                       parsed.getDate() === day
                    ? parsed
                    : null;
            }

            const isoDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input);
            if (isoDate) {
                const year = Number(isoDate[1]);
                const month = Number(isoDate[2]);
                const day = Number(isoDate[3]);
                const parsed = new Date(year, month - 1, day);

                return parsed.getFullYear() === year &&
                       parsed.getMonth() === month - 1 &&
                       parsed.getDate() === day
                    ? parsed
                    : null;
            }
        }

        return super.parse(value);
    }
}
